import { PaymentOrderType } from "api/paymentApi";
import { atom } from "recoil";

export const paymentOrderAtom = atom<PaymentOrderType>({
  key: "paymentOrder",
  default: undefined,
});
